import { create } from 'zustand';
export const useMissionNotificationStore = create((set) => ({
    hasUnviewedMissions: false,
    setHasUnviewedMissions: (hasUnviewedMissions) => set({ hasUnviewedMissions }),
}));
